import { render, staticRenderFns } from "./CreateTaskContent.vue?vue&type=template&id=41672c2b&scoped=true&"
import script from "./CreateTaskContent.vue?vue&type=script&lang=js&"
export * from "./CreateTaskContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskContent.vue?vue&type=style&index=0&id=41672c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41672c2b",
  null
  
)

export default component.exports